<template>
    <form id="contactForm">
        <div class="form-group row">
            <label for="inputname">Full Name</label>
            <input type="name" class="form-control" id="inputname" ng-model="comment_form.name" placeholder="Your name" autocomplete="name" required>
        </div>
        <div class="form-group row">
            <label for="inputemail">Email Address</label>
            <input type="email" class="form-control" id="inputemail" ng-model="comment_form.email" placeholder="Your email address" autocomplete="email" required>
        </div>
        <div class="form-group row">
            <label for="inputcomment">Message</label>
            <textarea class="form-control" rows="5" id="inputcomment" ng-model="comment_form.comment" required></textarea>
        </div>
    </form>
</template>

<script>
    export default {
        name: "ContactForm"
    }
</script>

<style scoped>
    #contactForm {
        color: black;
    }
</style>
